import React from "react";
import classNames from "classnames";
import gridTableStyles from "@design-system/Tables/GridTable/GridTableBase.module.scss";
import { Transaction } from "@common/types/transaction";
import { useInteraction } from "@hooks/useInteraction";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import { TransactionAmount } from "../../../transactions/TransactionAmount";
import { TransactionCategory } from "../../../transactions/TransactionCategory";
import styles from "./TransacitonToMerge.module.scss";

interface Props {
    transaction: Transaction;
    prepend?: React.ReactNode;
    onClick?: () => void;
    className?: string;
}

export const TransactionToMerge: React.FC<Props> = ({
    transaction,
    prepend,
    onClick,
    className,
}) => {
    const handleClick = useInteraction(onClick);

    return (
        <div
            className={classNames(gridTableStyles.row, className)}
            {...handleClick}
        >
            {prepend}
            <div className={styles.dateColumn}>
                {transaction.dateOnly
                    ? formatDateOnly(transaction.dateOnly)
                    : formatBusinessDate(transaction.date)}
            </div>
            <div>
                {transaction.displayDescription ?? transaction.bankDescription}
            </div>
            <div>
                <TransactionCategory transaction={transaction} />
            </div>
            <div className={styles.amountColumn}>
                <TransactionAmount transaction={transaction} addSign color />
            </div>
        </div>
    );
};
